import StaffingRegionsView from './StaffingRegions';

export default StaffingRegionsView;
